<template>
  <section class="message-section" id="message-section">
    <h2 class="section-title">在线留言</h2>
    <div class="message-card">
      <div class="message-side">
        <img class="side-img" src="@/assets/concat/bg1.png" alt="" />
      </div>
      <div class="message-form">
        <div class="form-row form-row-3">
          <input
            v-model="form.userName"
            class="form-input"
            type="text"
            placeholder="您的姓名"
            maxlength="20"
          />
          <input
            v-model="form.phone"
            class="form-input"
            type="text"
            placeholder="您的电话"
            maxlength="11"
          />
          <input
            v-model="form.address"
            class="form-input"
            type="text"
            placeholder="您所在的区域"
            maxlength="50"
          />
        </div>
        <textarea
          v-model="form.leaveMessage"
          class="form-textarea"
          placeholder="您的留言"
          maxlength="500"
        ></textarea>
        <button class="form-submit" :disabled="submitting" @click="onSubmit">
          {{ submitting ? "提交中..." : "提交留言" }}
          <i class="el-icon-right"></i>
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ContactMessageForm",
  data() {
    return {
      form: {
        userName: "",
        phone: "",
        address: "",
        leaveMessage: "",
        enterpriseId: "",
      },
      submitting: false,
    };
  },
  methods: {
    async onSubmit() {
      if (!this.form.userName.trim()) {
        this.$message.warning("请填写您的姓名");
        return;
      }
      if (!/^1\d{10}$/.test(this.form.phone.trim())) {
        this.$message.warning("请填写正确的 11 位手机号");
        return;
      }
      if (!this.form.leaveMessage.trim()) {
        this.$message.warning("请填写留言内容");
        return;
      }
      if (this.submitting) return;
      this.submitting = true;
      try {
        const res = await fetch(
          "https://tnnz.yungia.cn/api/bussnews/farmNews/leaveMessage",
          {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(this.form),
          }
        );
        if (res.ok) {
          this.$message.success("留言提交成功，我们会尽快与您联系");
          this.form = {
            userName: "",
            phone: "",
            address: "",
            leaveMessage: "",
            enterpriseId: "",
          };
          this.$emit("submitted");
        } else {
          this.$message.error("提交失败，请稍后重试");
        }
      } catch (e) {
        this.$message.error("网络异常，请稍后重试");
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.message-section {
  padding: 80px 0;
  background: #f5f8fe;
}

.section-title {
  font-size: 32px;
  font-weight: 600;
  color: #333333;
  text-align: center;
  margin: 0 0 40px;
}

.message-card {
  width: 1196px;
  margin: 0 auto;
  display: flex;
  background: #ffffff;
  overflow: hidden;
}

.message-side {
  width: 479px;
  height: 381px;
}

.side-img {
  width: 100%;
  height: 100%;
}

.message-form {
  flex: 1;
  padding: 48px;
  font-size: 16px;
}

.form-row {
  display: flex;
  gap: 24px;
  margin-bottom: 24px;

  &.form-row-3 {
    gap: 16px;
  }

  .form-input {
    flex: 1;
  }
}

.form-input,
.form-textarea {
  width: 100%;
  box-sizing: border-box;
  background: #f5f8fe;
  border: 1px solid transparent;
  border-radius: 8px;
  font-size: 15px;
  color: #333333;
  outline: none;
  transition: border-color 0.2s ease, background 0.2s ease;

  &::placeholder {
    color: #999999;
  }

  &:focus {
    border-color: #3982f7;
    background: #ffffff;
  }
}

.form-input {
  height: 52px;
  padding: 0 20px;
}

.form-textarea {
  height: 120px;
  padding: 16px 20px;
  resize: none;
  margin-bottom: 32px;
  font-family: inherit;
}

.form-submit {
  display: inline-flex;
  align-items: center;
  height: 44px;
  padding: 0 24px;
  background: #3982f7;
  color: #ffffff;
  font-size: 15px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: background 0.2s ease;

  i {
    margin-left: 6px;
  }

  &:hover {
    background: #2e6be6;
  }

  &:disabled {
    background: #a0c4ff;
    cursor: not-allowed;
  }
}
</style>
